import { clearSelectedAccountFilter, getGlobalFiltersFromStorage } from '@/utils/global-filters.util';

const saveGlobalFilter = (key, value) => {
    const globalFilters = getGlobalFiltersFromStorage();
    localStorage.setItem('globalFilters', JSON.stringify({ ...globalFilters, [key]: value }));
};

const setCountry = ({ commit }, payload) => {
    saveGlobalFilter('country', payload);
    commit('SET_COUNTRY', payload);
};

const setAccount = ({ commit }, payload) => {
    saveGlobalFilter('account', payload);
    commit('SET_ACCOUNT', payload);
};

const clearAccountFilter = ({ commit }) => {
    clearSelectedAccountFilter();
    commit('SET_ACCOUNT', 0);
};

export default {
    setCountry,
    setAccount,
    clearAccountFilter,
};
